<div class="premium-modal-wrapper">
    <ion-header class="ion-no-border premium-header">
        <div class="header-curve"></div>
        <div class="custom-toolbar">
            <div class="toolbar-content">
                <div class="icon-btn" (click)="dismiss()">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div class="title-group">
                    <div class="title-main">Reporte ARS #{{ trabajo.id }}</div>
                    <div class="title-sub">{{ trabajo.lugar }}</div>
                </div>
                <div class="icon-btn" style="visibility: hidden;">
                    <ion-icon name="close"></ion-icon>
                </div>
            </div>
        </div>
    </ion-header>

    <ion-content class="content-bg" [fullscreen]="false">
        <div class="ars-container ion-padding" *ngIf="!isLoading">

            <!-- Status Card: Fecha de Firma -->
            <div class="ars-card status-card">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="calendar-outline"
                            [color]="arsInfo.fecha_firma ? 'success' : 'medium'"></ion-icon>
                        <span>Fecha de Firma del Reporte</span>
                    </div>
                    <ion-badge [color]="arsInfo.fecha_firma ? 'success' : 'warning'" class="gen-badge">
                        {{ arsInfo.fecha_firma ? 'Firmado' : 'Sin Fecha' }}
                    </ion-badge>
                </div>
                <div class="status-details">
                    <div class="input-group">
                        <label>Fecha de Firma (Cliente)</label>

                        <!-- Sin fecha en DB -->
                        <div class="no-date-container" *ngIf="!arsInfo.fecha_firma">
                            <div class="no-date-message">
                                <ion-icon name="alert-circle-outline" color="warning"></ion-icon>
                                <span>Sin fecha de firma registrada</span>
                            </div>
                        </div>

                        <!-- Selector de Fecha -->
                        <div class="premium-input-wrapper date-input">
                            <input type="date" [(ngModel)]="fechaFirma" #dateInput [disabled]="isSaving">
                            <ion-icon name="calendar-outline" class="date-icon"
                                (click)="!isSaving ? dateInput.showPicker() : null"></ion-icon>
                        </div>
                    </div>

                    <div class="date-actions-container">
                        <ion-button expand="block" class="premium-btn-save" (click)="saveStatus()"
                            [disabled]="isSaving || !fechaFirma">
                            <ion-icon name="save-outline" slot="start"></ion-icon>
                            Guardar Fecha
                        </ion-button>

                        <ion-button expand="block" fill="outline" color="danger" class="btn-remove-date"
                            (click)="removeFecha()" [disabled]="isSaving" *ngIf="arsInfo.fecha_firma">
                            <ion-icon name="trash-outline" slot="start"></ion-icon>
                            Quitar Fecha
                        </ion-button>
                    </div>

                    <div class="status-row info-row" *ngIf="arsInfo.fecha_firma">
                        <span class="label">Fecha de firma en el sistema:</span>
                        <span class="value">{{ arsInfo.fecha_firma }}</span>
                    </div>
                </div>
            </div>

            <!-- Upload Card (If NOT has file) -->
            <div class="ars-card upload-card" *ngIf="!arsInfo.archivo_pdf">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="cloud-upload-outline" color="primary"></ion-icon>
                        <span>Subir Reporte (PDF)</span>
                    </div>
                </div>

                <div class="no-date-container" *ngIf="!hasCotizacionVinculada" style="margin-bottom: 12px;">
                    <div class="no-date-message">
                        <ion-icon name="alert-circle-outline" color="warning"></ion-icon>
                        <span>El trabajo debe tener una cotización vinculada para subir el reporte ARS.</span>
                    </div>
                </div>

                <div class="upload-zone"
                    (click)="(permissions?.trabajos?.rl_gestionar_ars === true && hasCotizacionVinculada) ? presentUploadOptionSheet() : (!hasCotizacionVinculada ? presentNoCotizacionToast() : null)"
                    [class.has-file]="selectedFile"
                    [class.read-only]="permissions?.trabajos?.rl_gestionar_ars !== true || !hasCotizacionVinculada">
                    <input type="file" #fileInput id="ars-file-input" (change)="onFileSelected($event)"
                        accept="application/pdf" style="display: none;">

                    <div class="upload-content" *ngIf="!selectedFile">
                        <ion-icon name="scan-outline"></ion-icon>
                        <p>Toca para escanear o subir reporte</p>
                        <span class="hint">Escanea con la cámara o selecciona un PDF</span>
                    </div>

                    <div class="file-info" *ngIf="selectedFile">
                        <ion-icon name="document-text-outline" color="primary"></ion-icon>
                        <div class="file-name-container">
                            <span class="file-name">{{ fileName }}</span>
                            <span class="file-size">Nuevo archivo por subir</span>
                        </div>
                        <ion-button fill="clear" (click)="selectedFile = null; $event.stopPropagation()">
                            <ion-icon name="trash-outline" color="danger"></ion-icon>
                        </ion-button>
                    </div>
                </div>

                <ion-button expand="block" class="upload-btn" (click)="uploadPdf()"
                    [disabled]="!selectedFile || isSaving || !hasCotizacionVinculada" *ngIf="permissions?.trabajos?.rl_gestionar_ars === true">
                    <ion-spinner name="crescent" *ngIf="isSaving"></ion-spinner>
                    <span *ngIf="!isSaving">Subir Reporte</span>
                </ion-button>
            </div>

            <!-- Upload Card (If already has file, show in premium-file-card style) -->
            <div class="ars-card upload-card" *ngIf="arsInfo.archivo_pdf">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="document-text-outline" color="success"></ion-icon>
                        <span>Reporte ARS Registrado</span>
                    </div>
                    <ion-badge color="success" class="gen-badge">Subido</ion-badge>
                </div>

                <p class="informe-desc">Toca el archivo para ver, editar o eliminar el reporte ARS.</p>

                <div class="premium-file-card" (click)="presentArsActionSheet()">
                    <div class="file-card-left">
                        <div class="pdf-icon-wrapper pdf-success">
                            <ion-icon name="document-text" color="success"></ion-icon>
                        </div>
                        <div class="file-card-details">
                            <span class="file-card-name">{{ arsInfo.archivo_pdf }}</span>
                            <span class="file-card-subtitle">Toca para ver opciones</span>
                        </div>
                    </div>
                    <ion-icon name="ellipsis-vertical-outline" class="options-dots-icon"></ion-icon>
                </div>

                <input type="file" #fileInput id="ars-file-input" (change)="onFileSelected($event)"
                    accept="application/pdf" style="display: none;">
            </div>

            <!-- Informe Fotográfico -->
            <div class="ars-card informe-card">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="images-outline" color="warning"></ion-icon>
                        <span>Informe Fotográfico</span>
                    </div>
                    <ion-badge *ngIf="informeGenerado" color="success" class="gen-badge">Generado</ion-badge>
                </div>

                <!-- Sin informe generado en sesión -->
                <ng-container *ngIf="!informeGenerado">
                    <p class="informe-desc">Selecciona imágenes de Antes y Después de la galería del trabajo para
                        generar un informe fotográfico.</p>
                    <ion-button expand="block" class="premium-btn-warning" (click)="openInformeFotografico()">
                        <ion-icon name="add-circle-outline" slot="start"></ion-icon>
                        Crear Informe
                    </ion-button>
                </ng-container>

                <!-- Informe generado exitosamente -->
                <ng-container *ngIf="informeGenerado">
                    <p class="informe-desc">Toca el archivo para ver, editar o eliminar el informe fotográfico generado.
                    </p>
                    <div class="premium-file-card" (click)="presentInformeActionSheet()">
                        <div class="file-card-left">
                            <div class="pdf-icon-wrapper">
                                <ion-icon name="document-text" color="danger"></ion-icon>
                            </div>
                             <div class="file-card-details">
                                 <span class="file-card-name">{{ arsInfo.if_pdf }}</span>
                                 <span class="file-card-subtitle">Toca para ver opciones</span>
                             </div>
                        </div>
                        <ion-icon name="ellipsis-vertical-outline" class="options-dots-icon"></ion-icon>
                    </div>
                </ng-container>
            </div>

            <!-- Informe de Trabajo Final (ITF) -->
            <div class="ars-card final-report-card" *ngIf="arsInfo.archivo_pdf && arsInfo.if_pdf">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="ribbon-outline" color="secondary"></ion-icon>
                        <span>Informe de Trabajo Final (ITF)</span>
                    </div>
                    <ion-badge *ngIf="inftGenerado" color="secondary" class="gen-badge">Generado</ion-badge>
                </div>

                <p class="informe-desc">Combina el reporte ARS y el informe fotográfico en un solo documento final.</p>

                <!-- Si ya existe el informe de trabajo final generado -->
                <ng-container *ngIf="inftGenerado">
                    <div class="premium-file-card" (click)="presentInftActionSheet()">
                        <div class="file-card-left">
                            <div class="pdf-icon-wrapper pdf-inft">
                                <ion-icon name="document-text" color="secondary"></ion-icon>
                            </div>
                            <div class="file-card-details">
                                <span class="file-card-name">{{ inftFileName }}</span>
                                <span class="file-card-subtitle">Toca para ver opciones</span>
                            </div>
                        </div>
                        <ion-icon name="ellipsis-vertical-outline" class="options-dots-icon"></ion-icon>
                    </div>
                </ng-container>

                <!-- Si no existe el informe de trabajo final -->
                <ng-container *ngIf="!inftGenerado">
                    <ion-button expand="block" class="premium-btn-secondary" (click)="generarInformeFinal()"
                        [disabled]="isSaving">
                        <ion-spinner name="crescent" *ngIf="isSaving"></ion-spinner>
                        <ion-icon name="git-merge-outline" slot="start" *ngIf="!isSaving"></ion-icon>
                        <span *ngIf="!isSaving">Generar Informe Final</span>
                    </ion-button>
                </ng-container>
            </div>

        </div>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="isLoading">
            <ion-spinner name="crescent" color="primary"></ion-spinner>
            <p>Cargando información ARS...</p>
        </div>
    </ion-content>

    <ion-footer class="ion-no-border premium-list-footer"></ion-footer>
</div>